import 'remixicon/fonts/remixicon.css';
import React from 'react';
import { TeacherData } from '../../store/viewmodels/TeacherViewModel';
import { useAppSelector } from '../../store/Hooks';
import { Task } from '../../store/viewmodels/TaskViewModel';
import DualTaskItemSetSelection from '../utils/DualTaskItemSetSelection';
import { createStudents } from '../../store/TeacherSlice';
import { useAppDispatch } from '../../store/Hooks';

export interface CreateKeysModalProps {
    close: () => void;
}

function CreateKeysModal(props: CreateKeysModalProps) {

    const [amount, setAmount] = React.useState(0);
    const [groupName, setGroupName] = React.useState("");
    const [tasksIds, setTasksIds] = React.useState<number[]>([]);
    const [itemsetIds, setItemsetIds] = React.useState<number[]>([]);

    const [errorMessage, setErrorMessage] = React.useState("");
    const [disabledButton, setDisabled] = React.useState(true);

    const teacherData: TeacherData = useAppSelector(state => state.teacherData);
    const isTeacher: boolean = teacherData.isAuthenticated;

    let tasks: Task[] = [];
    if (teacherData.teacher?.licences?.length > 0) {
        tasks = teacherData.teacher.licences[0].tasks;
    }
    const dispatch = useAppDispatch()

    const MAX_AMOUNT = 1000; //TODO: get this from licence
    const MAX = 100;

    let options = tasks;

    const handleAmountChange = (event: any) => {
        if (event.target.value < 0) {
            setErrorMessage("Et voi luoda alle 0 tunnusta.")
            setDisabled(true);
        }
        if (event.target.value > MAX) {
            setErrorMessage("Voit luoda kerralla enintään " + MAX + " tunnusta.")
        }
        if (event.target.value > MAX_AMOUNT) {
            setErrorMessage("Et voi luoda enempää tunnuksia, mitä lisenssissä on jäljellä.")
            setDisabled(true);
        }
        else if (event.target.value > 0 && event.target.value <= MAX_AMOUNT && event.target.value <= MAX) {
            setAmount(event.target.value);
            setErrorMessage("");
            if (isTeacher) { setDisabled(false); }
        }
    }

    const handleGroupChange = (event: any) => {
        setGroupName(event.target.value);
    }

    const handleSave = (event: any) => {
        const teacherId = teacherData.teacher.id;
        const postObject = { amountRequest: amount, teacherId: teacherId, group: groupName, task_access_list: tasksIds, active_item_sets: itemsetIds };
        dispatch(createStudents(postObject));
        props.close();
    }

    let buttonCSS = !disabledButton ? "hover:bg-teal-400 focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-offset-2 focus:ring-teal-500" : "disabled:opacity-50 cursor-not-allowed";
    let errorCSS = errorMessage.length === 0 ? "pt-6 block" : "text-red-600 block";

    return (
        <div className="m-6 w-full">
            <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-900">Luo oppilaita</h2>
            <div className={errorCSS}>{errorMessage}</div>
            <form className="w-full ">
                <div className="items-center mb-4">
                    <label className="text-gray-500 font-bold text-right">Määrä</label>
                    <p className="text-xs">Luotavien oppilaiden määrä.</p>
                    <input id="amount" name="amount" type="number" placeholder="0" value={amount} onChange={handleAmountChange}
                        className="bg-gray-200 appearance-none border-2 border-gray-200 
                    rounded w-full py-2 px-4 text-gray-700 leading-tight 
                    focus:outline-none focus:bg-white focus:border-teal-500"/>
                    <p className="text-xs">{"Voit luoda enimmillään " + MAX + " tunnusta kerrallaan."}</p>
                </div>
                <div className="items-center mb-4">
                    <label className="text-gray-500 font-bold text-right">Ryhmä</label>
                    <input id="group" name="group" type="group" placeholder="ryhmän nimi" value={groupName} onChange={handleGroupChange}
                        className="
                    bg-gray-200 appearance-none border-2 border-gray-200 
                    rounded w-full py-2 px-4 text-gray-700 leading-tight 
                    focus:outline-none focus:bg-white focus:border-teal-500"/>
                </div>
                <div className="items-center mb-4 ">
                    <label className="text-gray-500 font-bold text-right">Teemat ja tehtävät</label>
                    <p className="text-xs">
                        Valitse listasta oppilaille käytettävissä olevat teemat tehtävineen.
                        Valintaa voi muuttaa myöhemmin oppilaskohtaisesti.</p>
                </div>
                <DualTaskItemSetSelection selectableTasks={options} itemset_access_list={[]} setItemsetIds={setItemsetIds} setTasksIds={setTasksIds} />
                <div className="mt-4 w-1/2 flex">
                    <div className="w-1/2 mr-1">
                        <button
                            onClick={handleSave}
                            type="button"
                            disabled={disabledButton}
                            className={"block w-full text-sm font-medium rounded-md border-transparent bg-teal-600 text-white font-bold py-2 px-4 " + buttonCSS}>
                            Luo
                        </button>
                    </div>
                    <div className="w-1/2 ml-1">
                        <button
                            onClick={props.close}
                            type="button"
                            className="block w-full text-sm font-medium rounded-md border-transparent bg-gray-500 hover:bg-gray-400 focus:shadow-outline text-white font-bold py-2 px-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                            Peruuta
                        </button>
                    </div>
                </div>
            </form>
        </div>

    );
}

export default CreateKeysModal;